import { forwardRef } from 'react';

type ProfileButtonProps = {
  onClick: () => void;
  isMenuOpen: boolean;
};

export default forwardRef<HTMLDivElement, ProfileButtonProps>(function ProfileButton({ onClick, isMenuOpen }, ref) {
  return (
    <div
      ref={ref}
      className="w-14 h-10 py-2.5 px-4 bg-[#F4F4F4] rounded-3xl border border-[#E5E7EB] inline-flex justify-center items-center cursor-pointer relative"
      onClick={onClick}
      aria-haspopup="menu"
      aria-expanded={isMenuOpen}
    >
      <img src="/profile.svg" alt="Profile" className="w-4 h-4" />
    </div>
  );
});
